import Vue from "vue"
import Vuex from "vuex"

import loginStore from "../modules/login/loginStore.js";

import imobiliariasStore from "../modules/imobiliarias/imobiliariasStore";
import imobiliariaPreCadastradaStore from '../modules/cadastro/imobiliaria/imobiliariaPreCadastradaStore';
import bairrosStore from '../modules/cadastro/bairro/bairrosStore';
import cidadesStore from '../modules/cadastro/cidade/cidadesStore';
import condominioStore from '../modules/cadastro/caracteristicas/condominio/condominioStore';
import imovelStore from '../modules/cadastro/caracteristicas/imovel/imovelStore'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false
  },
  // MUTATIONS
  mutations: {
    showLoading(state) {
      state.loading = true;
    },
    hideLoading(state) {
      state.loading = false;
    }
  },

  //ACTIONS
  actions: {
    showLoading(context) {
      context.commit("showLoading")
    },
    hideLoading(context) {
      context.commit("hideLoading")
    }
  },

  modules: {
    loginStore: {
      namespaced: true,
      ...loginStore
    },

    imobiliariasStore: {
      namespaced: true,
      ...imobiliariasStore
    },

    imobiliariaPreCadastradaStore: {
      namespaced: true,
      ...imobiliariaPreCadastradaStore,
    },

    bairrosStore: {
      namespaced:true,
      ...bairrosStore
    },

    cidadesStore: {
      namespaced:true,
      ...cidadesStore
    },

    condominioStore: {
      namespaced: true,
      ...condominioStore
    },

    imovelStore: {
      namespaced: true,
      ...imovelStore
    }
  },
});